import request from "./api";
/**
 *    achievement 科目api
 *                         Author by zyp. on 2020.06.22
 *
 * */

//  教师端 获取成绩列表
export const getAchievementList = (params, opts) =>
    request('/api-data/scoremanage/course/students', params, {
        ...opts,
        method: 'post'
    });

//  教师端 点击课程列表详情
export const getAchievementCourseHead = (params, opts) =>
    request('/api-data/scoremanage/get/courseAndstudent/info', params, {
        ...opts,
        method: 'post'
    });

//  教师端 课件学习列表
export const getAchievementCourseLearn = (params, opts) =>
    request('/api-data/scoremanage/courseware/learn', params, {
        ...opts,
        method: 'post'
    });
//  教师端 课件学习列表
export const getAchievementCourseList = (id, params, opts) =>
    request('/api-course/catalog/catalog/v2/query'+id, params, {
        ...opts,
   
    });
//  教师端 单元测验列表
export const getAchievementTestList = (params, opts) =>
    request('/api-data/scoremanage/unit/exam', params, {
        ...opts,
        method: 'post'
    });
//  教师端 更新成绩
export const clickUpdata = (params, opts) =>
    request('/api-data/scoremanage/update/score', params, {
        ...opts,
        method: 'post'
    });


// WEBPACK FOOTER //
// ./src/api/achievementApi.js